import {AlbumSummary} from './AlbumSummary';
import { ArtistSummary } from './ArtistSummary';

export class AlbumSummaryWithArtist extends AlbumSummary {
  artist: ArtistSummary;
  // the sortPosition isn't returned in the JSON but is implied by the
  // order of albums in the array in the JSON response.  we lose that 
  // array when we create this object, so we set the sortPosition at 
  // the time this object is created.
  sortPosition: number;

  constructor(artistSummary: ArtistSummary, sortPosition: number) {
    super();
    this.artist = artistSummary;
    this.sortPosition = sortPosition;
  }

}
